import StoniTenis from './StoniTenis'

const Badminton = () => <StoniTenis calculatorType={'Badminton'} />

export default Badminton
